<template>
  <div>
    <div class="main-bottom-wrap">
      <div>
        <div class="main-bottom-title mobile">
          국회의원<br />1호 법안 상황판
        </div>
        <div class="main-bottom-sub mobile">
          22대 국회 개원 후<br />국회의원별 최초 발의한 법안
        </div>
        <img
          class="main-bottom-img"
          :src="require('../../assets/img/congressman.jpg')"
          alt="이미지"
        />
        <div class="main-bottom-title pc">국회의원 1호 법안 상황판</div>
        <div class="main-bottom-sub pc">22대국회 의원별 최초 발의법안</div>
        <RouterLink to="/congressman-bill" class="main-botton-btn"
          >자세히보기</RouterLink
        >
      </div>
      <div>
        <div class="main-bottom-title mobile">
          상임위원회<br />법안처리 현황
        </div>
        <div class="main-bottom-sub mobile">
          상임위원회별<br />회부된 법안의 처리현황
        </div>
        <img
          class="main-bottom-img"
          :src="require('../../assets/img/standing.jpg')"
          alt="이미지"
        />
        <div class="main-bottom-title pc">상임위원회 법안처리 현황</div>
        <div class="main-bottom-sub pc">
          상임위원회별 회부된 법안의 처리현황
        </div>
        <RouterLink to="/standing-committee-bill" class="main-botton-btn"
          >자세히보기</RouterLink
        >
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "MainBottom",
  components: { RouterLink },
};
</script>

<style scoped>
.main-bottom-wrap {
  margin: 100px 0;
  gap: 40px;
  display: flex;
  justify-content: center;
  position: absolute;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);

  @media only screen and (max-width: 1040px) {
    height: auto;
    position: relative;
    flex-direction: column;
    left: auto;
    transform: none;
    padding: 0 6vw;
    margin: 10vw 0;
    text-align: center;
  }
}

.main-bottom-img {
  width: 640px;
  height: 400px;
  border-radius: 20px;

  @media only screen and (max-width: 1380px) {
    width: 550px;
    height: auto;
  }

  @media only screen and (max-width: 1200px) {
    width: 450px;
    height: auto;
  }

  @media only screen and (max-width: 1040px) {
    width: 100%;
  }
}

.main-bottom-title {
  font-family: GmarketSansMedium;
  font-size: 50px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.25px;
  color: #000;
  margin-top: 50px;

  &.mobile {
    display: none;
  }

  @media only screen and (max-width: 1200px) {
    font-size: 40px;

    &.pc {
      display: none;
    }

    &.mobile {
      display: block;
      text-align: center;
      margin-bottom: 58px;
    }
  }
}

.main-bottom-sub {
  margin-top: 29px;
  font-family: GmarketSansMedium;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.75px;
  color: #666;

  &.mobile {
    display: none;
  }

  @media only screen and (max-width: 1200px) {
    font-size: 23px;

    &.pc {
      display: none;
    }

    &.mobile {
      display: block;
      text-align: center;
      font-size: 3vw;
      margin-bottom: 59px;
    }
  }
}

.main-botton-btn {
  background-color: #005aab;
  width: 200px;
  height: 60px;
  line-height: 60px;
  border-radius: 30px;
  color: #fff;
  font-family: GmarketSansMedium;
  display: inline-block;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.5px;
  margin-top: 50px;
  color: #fff;
}
</style>
